export type TraderScope = 'none' | 'all' | 'enabled' | 'selected';
export type MerchantScope = 'none' | 'all' | 'not_blocked' | 'selected';

export default interface TelegramBroadcastAudienceSpec {
  traderScope: TraderScope;
  traderIds: number[];
  merchantScope: MerchantScope;
  merchantIds: number[];
  merchantTgGroupIds: number[];
}

export function createEmptyTelegramBroadcastAudienceSpec(): TelegramBroadcastAudienceSpec {
  return {
    traderScope: 'none',
    traderIds: [],
    merchantScope: 'none',
    merchantIds: [],
    merchantTgGroupIds: [],
  };
}

export function normalizeTelegramBroadcastSpec(spec: TelegramBroadcastAudienceSpec): TelegramBroadcastAudienceSpec {
  return {
    traderScope: spec.traderScope,
    traderIds: spec.traderScope === 'selected' ? [...spec.traderIds] : [],
    merchantScope: spec.merchantScope,
    merchantIds: spec.merchantScope === 'selected' ? [...spec.merchantIds] : [],
    merchantTgGroupIds: [...spec.merchantTgGroupIds],
  };
}

export function isMeaningfulTelegramBroadcastSpec(spec: TelegramBroadcastAudienceSpec): boolean {
  if (spec.merchantTgGroupIds.length > 0) {
    return true;
  }
  if (spec.traderScope !== 'none') {
    return true;
  }
  if (spec.merchantScope !== 'none') {
    return true;
  }
  return false;
}
